import Filter from "components/dashboard/common/Filter/Filter";
import Heading from "components/ui/Heading/Heading";

const DiscoveryHeader = ({
    handleSearch,
    searchIsLoading,
    clearSearch,
    handleSortByAlpha,
    handleSortByDate,
    handleSortByLastModified, baseFilter, filterOption, handleBasefilter, searchDefaultValue
}) => {
    return (
        <>
            <Heading
                headingText='Discovery'
                headingSubText='Add & change your discoveries'
            />
            <Filter
                handleSortByAlpha={handleSortByAlpha}
                handleSortByDate={handleSortByDate}
                handleSearch={handleSearch}
                handleSortByLastModified={handleSortByLastModified}
                searchPlaceholder='Search discoveries here'
                searchIsLoading={searchIsLoading}
                clearSearch={clearSearch}
                hideClassFilter
                baseFilter={baseFilter}
                filterOption={filterOption}
                handleBasefilter={handleBasefilter}
                searchDefaultValue={searchDefaultValue}
            />
        </>
    );
};

export default DiscoveryHeader;
